
import { atom } from "jotai";
import { paymentFilterGroups } from "./predicate";
import { PaymentFilterAtom } from "./type";

const paymentFilters: PaymentFilterAtom = {
  filterGroup: paymentFilterGroups,
  filterValues: {},
  activeFilterKeys: ["from_date", "date_range", "to_date", "modes", "statuses"],
  sorting: {
    sort_col: "DEFAULT",
    order: 'DESC',
  },
};

export const paymentFiltersAtom = atom(paymentFilters);
